import React from 'react';
import ReactDom from 'react-dom';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import {Tex} from 'react-tex';

class SIUnitsStudy extends React.Component{


render(){

  //Here are the tex constants that will be put in SI units


  return(

<MuiThemeProvider>

  <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderColumn>Uses</TableHeaderColumn>
            <TableHeaderColumn>SI Units</TableHeaderColumn>
            <TableHeaderColumn style = {{textAlign: 'center'}}>Answer Format</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableRowColumn> <span> Work and Energy </span> </TableRowColumn>
            <TableRowColumn> <span> Joule (J) = N(m) </span>  </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>   <span> N*m </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn><span> Power </span> </TableRowColumn>
            <TableRowColumn><span> Watt (W) = J/s  </span> </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>  <span> J/s </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn><span> Pressure </span> </TableRowColumn>
            <TableRowColumn><span> Pascal (Pa) = N/(m <sup> 2 </sup>) </span> </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>  <span> N/(m^2)  </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn><span> Current </span> </TableRowColumn>
            <TableRowColumn> <span> Ampere (A) = C/s </span>  </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>   <span> C/s  </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn><span> Electric Potential </span> </TableRowColumn>
            <TableRowColumn> <span> Volt (V) = J/C </span> </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>  <span> J/C </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn><span> Resistance  </span> </TableRowColumn>
            <TableRowColumn> <span> Ohm (Ω) = V/A </span> </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>   <span> V/A </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn><span> Capacitance </span> </TableRowColumn>
            <TableRowColumn> <span> Farad (F) = C/V </span>  </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>  <span> C/V </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn><span> Force </span> </TableRowColumn>
            <TableRowColumn> <span> Newton (N) = (kg ⋅ m)/s<sup>2</sup> </span>  </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>  <span> (kg*m)/(s^2) </span> </TableRowColumn>
          </TableRow>
          <TableRow>
            <TableRowColumn><span> Frequency </span> </TableRowColumn>
            <TableRowColumn> <span> Hertz (Hz) = 1/s </span>  </TableRowColumn>
            <TableRowColumn style = {{textAlign: 'center'}}>  <span> 1/s </span> </TableRowColumn>
          </TableRow>
        </TableBody>
      </Table>

      </MuiThemeProvider>

);
}

}

export default SIUnitsStudy;



// WEBPACK FOOTER //
// ./src/SIUnits/SIUnitsStudy.js